import Box from '@mui/material/Box';
import { observer } from 'mobx-react';
import CloverleafImage from "./image/Cloverleaf.png";
import { useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Button, Grid } from '@mui/material';
import { useStore } from "../../state/MobxContext";
import { useEffect } from 'react';
// import { debug } from '../../utils/UtilConsole';
// import { red, green } from '@mui/material/colors';






function CloverMissionBar() {

    const { loginStore } = useStore();
    const { MissionStore } = useStore();

    const isMobile = useMediaQuery("(max-width: 600px)");
    const isSm = useMediaQuery("(max-width: 900px)");

    // const buttonColor = green[300];


    const WhiteTextCloverTypography = withStyles({
        root: isMobile ?
            {
                fontSize: '0.8rem',
                color: "#FFFFFF",
                fontWeight: 'bold'
            }
            :
            isSm ?
                {
                    fontSize: '2rem',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
                :
                {
                    fontSize: '3rem',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
    })(Typography);



    const WhiteTextTimeTypography = withStyles({
        root: isMobile ?
            {
                fontSize: '0.7em',
                color: "#FFFFFF",
                fontWeight: 'bold'
            }
            :
            isSm ?
                {
                    fontSize: '1.3em',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
                :
                {
                    fontSize: '2em',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
    })(Typography);

    const WhiteTimeTypography = withStyles({
        root: isMobile ?
            {
                fontSize: '0.8em',
                color: "#FFFFFF",
                fontWeight: 'bold'
            }
            :
            isSm ?
                {
                    fontSize: '2em',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
                :
                {
                    fontSize: '2.7em',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
    })(Typography);



    const WhiteUpgradeTypography = withStyles({
        root: isMobile ?
            {
                fontSize: '0.5em',
                color: "#FFFFFF",
                fontWeight: 'bold'
            }
            :
            isSm ?
                {
                    fontSize: '0.7em',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
                :
                {   
                    fontSize: '1em',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
    })(Typography);



    let RemainTime = MissionStore?.RemainTime;
    let RemainHoursTime = MissionStore?.RemainHoursTime;
    let RemainMinsTime = MissionStore?.RemainMinsTime;
    let RemainSecsTime = MissionStore?.RemainSecsTime;
    const member_no = loginStore?.loginState?.member_no;
    const email_address = loginStore?.loginState?.email_address;
    const isRecommenderPage = loginStore.isRecommenderPage;
    const MissionMemberState = MissionStore?.MissionLevelState;
    // const AllLevel = MissionMemberState?.pmg_mission_level + MissionMemberState?.cag_mission_level
    const AllLevel = MissionMemberState?.pmg_mission_level + MissionMemberState?.cag_mission_level + MissionMemberState?.golf_mission_level; //골프



    let Guide_clover_page_CloverMissionBar_01 = loginStore?.Guide_clover_page_CloverMissionBar_01; //Mission
    let Guide_clover_page_CloverMissionBar_02 = loginStore?.Guide_clover_page_CloverMissionBar_02; //업그레이드! 클릭
    let Guide_clover_page_CloverMissionBar_03 = loginStore?.Guide_clover_page_CloverMissionBar_03; //Limit


    useEffect(() => {//미션 초기화 타이머
        // console.log("MiningTimer");
        // MainTimeLimit();
        const member_no = loginStore?.loginState?.member_no;
        let RemainTime = MissionStore?.RemainTime;
        const countdown = setInterval(() => {
            if (member_no !== undefined || member_no !== null || member_no !== "") {
                if (RemainTime > 0) {
                    // console.log("MiningTimerRemainSecondSec");
                    MissionStore.setRemainTime(RemainTime - 1);
                }
                if (RemainTime === 0) {
                    // console.log("getUserMissionCount");
                    if (email_address !== undefined || email_address !== null || email_address !== "") {
                        // MissionStore.getUserMissionCount();
                    }

                }
            }
            else {
                clearInterval(countdown);
            }
        }, 1000);
        // MainTimeLimit("E");
        return () => clearInterval(countdown);
        // eslint-disable-next-line
    }, [RemainTime, RemainSecsTime, RemainMinsTime, member_no]);

    useEffect(() => {
        const member_no = loginStore?.loginState?.member_no;
        // eslint-disable-next-line
        if (member_no == undefined || member_no == null || member_no == "") {
            MainTimeLimit("GOOD");
        }
        // eslint-disable-next-line
    }, [member_no])



    const MainTimeLimit = (value) => {
        // debug(value);
        const today = new Date();
        // const Coday = Date.now("08:00:00");
        // const Cday = new Date(Coday);
        // console.log(Coday);
        // console.log(Cday);

        // const Coday = new Date(" 08:00:00");
        // const OnT = `${Coday.year}-${Coday.month}-${Coday.date} ${Coday.hours}:${Coday.minutes}:${Coday.seconds}`;

        // const oneday = Coday + parseInt(86400000);

        // const ODay = new Date(oneday);

        // let onetime = {
        //     year: ODay.getFullYear(),  //현재 년도
        //     month: ODay.getMonth() + 1, // 현재 월
        //     date: ODay.getDate(), // 현제 날짜
        //     hours: ODay.getHours(), //현재 시간
        //     minutes: ODay.getMinutes(), //현재 분
        //     seconds: ODay.getSeconds() //현재 초
        // };

        // const OneT = `${onetime.year}-${onetime.month}-${onetime.date} ${onetime.hours}:${onetime.minutes}:${onetime.seconds}`;
        // console.log(ODay);
        // console.log(OneT);

        // let Ytime = {
        //     year: today.getFullYear(),  //현재 년도
        //     month: today.getMonth() + 1, // 현재 월
        //     date: today.getDate() + 1, // 현제 날짜
        //     hours: today.getHours(), //현재 시간
        //     minutes: today.getMinutes(), //현재 분
        //     seconds: today.getSeconds() //현재 초
        // };
        // let Ttime = {
        //     year: today.getFullYear(),  //현재 년도
        //     month: today.getMonth() + 2, // 현재 월
        //     date: today.getDate(), // 현제 날짜
        //     hours: today.getHours(), //현재 시간
        //     minutes: today.getMinutes(), //현재 분
        //     seconds: today.getSeconds() //현재 초
        // };
        let Etime = {
            year: today.getFullYear(),  //현재 년도
            month: today.getMonth() + 1, // 현재 월
            date: today.getDate(0), // 현제 날짜
            hours: today.getHours(), //현재 시간
            minutes: today.getMinutes(), //현재 분
            seconds: today.getSeconds() //현재 초
        };
        const TD = new Date(`${Etime?.year}-${Etime?.month}-${Etime?.date} 08:00:00`);
        let ToTime = Date.now()
        const TA = TD.getTime();
        const ttt = TA + 86400000;
        const TR = new Date(ttt);

        // let todayE = new Date(`${Ytime?.year}-${Ytime?.month}-${Ytime?.date} 08:00:00`);
        // debug("FE",todayE);
        let count = TR - ToTime;
        // console.log(count);
        let secondsCount = Math.floor(count / 1000);
        MissionStore.setRemainTime(secondsCount)

        
    }



    return (
        <div>
            <Grid container maxWidth='xl' minWidth='full' whiteSpace="pre-wrap" >
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                    <Box sx={isMobile ? { bgcolor: '#66bb6a', maxWidth: '100%', mx: 'auto', p: 1 }
                        : { bgcolor: '#66bb6a', maxWidth: '100%', mx: 'auto', p: 1, paddingBottom: 0 }} >
                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} direction='row' justifyContent="flex-start" alignItems='center'   >
                                <img style={isMobile ? { width: '25%' } : { width: '15%' }} src={CloverleafImage} alt="Cloverleaf" />
                                <WhiteTextCloverTypography >{Guide_clover_page_CloverMissionBar_01}</WhiteTextCloverTypography>
                            </Grid>
                            {isRecommenderPage ?
                                <Grid container item xs={4} sm={4} md={4} lg={4} xl={4}
                                    direction='column' justifyContent="space-between" alignItems='center'
                                    onClick={(e) => { loginStore.setDialogOpen("GameMission") }}>
                                    <Button variant="outlined" color="inherit" 
                                        sx={isMobile ? { width: "80%", padding: 0, margin: 0, borderRadius: 50, border: 1, fontSize: '0.5rem', minWidth: 40, minHeight: 20, color: 'white', fontWeight: 'bold' }
                                            :
                                            { width: '40%', padding: 0.5, margin: 0, color: 'white', fontWeight: 'bold', fontSize: '1.3rem', borderRadius: 25, border: 2 }}  >
                                        M.lv{AllLevel}</Button>

                                    <WhiteUpgradeTypography style={{ marginTop: "3%" }}>{Guide_clover_page_CloverMissionBar_02}</WhiteUpgradeTypography>
                                </Grid>
                                :
                                <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} direction='row' justifyContent="center" alignItems='center' />
                            }
                            <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} direction='row' justifyContent="flex-end" alignItems='center' gap={isMobile ? 1 : 2} >
                                <WhiteTextTimeTypography  >{Guide_clover_page_CloverMissionBar_03}</WhiteTextTimeTypography>
                                {/* <Grid item xs={1} sm={1} md={1} lg={1} xl={1} /> */}
                                <WhiteTimeTypography >
                                    {RemainHoursTime !== undefined || RemainHoursTime !== null || RemainHoursTime !== "" ? RemainHoursTime + ":" + RemainMinsTime + ":" + RemainSecsTime : "00:45:00"}
                                </WhiteTimeTypography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

            </Grid>
        </div>
    );
};


export default observer(CloverMissionBar);